import { render, staticRenderFns } from "./CancelAllTournaments.vue?vue&type=template&id=31b1c384&lang=pug"
import script from "./CancelAllTournaments.vue?vue&type=script&lang=js"
export * from "./CancelAllTournaments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports